module.exports = __webpack_public_path__ + "static/media/download.469672bd.svg";